export var host = "https://avwapp.com"
//export var host = "http://localhost:8080"
